import React, { useState } from "react"
import PropTypes from "prop-types"
import { Col, Container, Row, Spinner, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap"
import { withTranslation } from "react-i18next"
import classnames from "classnames"
import Select from "react-select"
import { computeReportStats } from "components/Common/reportUtils.js"
import DateRangeSelector from "components/Common/DateRangeSelector.js"
import ReportStatsView from "components/Common/ReportStatsView.js"
import { loadReportsHelper } from "helpers/loadReports"

const Dashboard = props => {
  const user = JSON.parse(localStorage.getItem("authUser"))
  document.title = "Dashboard | CurbDash"

  const [loading, setLoading] = useState(false)
  const [progressMessages, setProgressMessages] = useState([])
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [reports, setReports] = useState({})
  const [selectedLocations, setSelectedLocations] = useState([{ label: "All Locations", value: "All Locations" }])
  const [locations, setLocations] = useState([])
  const [activeTab, setActiveTab] = useState("COMBINED")

  const loadReports = async (start, end, selected = [{ value: "All Locations" }]) => {
    setLoading(true)
    setProgressMessages([])

    try {
      const data = await loadReportsHelper({
        token: user.token,
        start,
        end,
        selected,
        setProgressMessages,
        setLocations,
        setActiveTab,
      })
      setReports(data || {})
    } finally {
      setStartDate(start)
      setEndDate(end)
      setLoading(false)
      setProgressMessages([])
    }
  }

  const combinedStats = computeReportStats(Object.values(reports), true)

  return (
    <div className="page-content" style={{ marginTop: -70, backgroundColor: "rgb(38, 37, 35)" }}>
      <Container fluid>
        <Row className="d-flex mb-4 align-items-center justify-content-center">
          <Col xl={"auto"} style={{ minWidth: "250px" }}>
            <Select
              className="accordion-gradient-border"
              value={selectedLocations}
              onChange={options => {
                const safeOptions = options && options.length > 0 ? options : [{ label: "All Locations", value: "All Locations" }]
                setSelectedLocations(safeOptions)
                loadReports(startDate, endDate, safeOptions)
              }}
              isMulti
              styles={{
                control: base => ({ ...base, fontSize: "16px" }),
                multiValue: base => ({ ...base, fontSize: "16px" }),
                option: base => ({ ...base, fontSize: "16px" }),
                menu: base => ({ ...base, backgroundColor: "white", zIndex: 9999 }),
              }}
              options={locations}
              isSearchable
            />
          </Col>
          <Col xl="auto" className="mt-3">
            <DateRangeSelector onApply={(s, e) => loadReports(s, e, selectedLocations)} />
          </Col>
        </Row>

        {loading ? (
          <div className="text-center my-5">
            <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
            {progressMessages.map((msg, i) => (
              <div key={i} style={{ marginTop: 10, fontSize: 16, color: "#fff" }}>
                {msg}
              </div>
            ))}
          </div>
        ) : (
          <>
            {selectedLocations.some(sel => sel.value === "All Locations") ? (
              <ReportStatsView stats={combinedStats} />
            ) : (
              <>
                <Nav tabs className="justify-content-center">
                  {Object.keys(reports).map(loc => {
                    return (
                      <NavItem key={loc} className="accordion-gradient-border">
                        <NavLink
                          className={classnames({ active: activeTab === loc })}
                          onClick={() => setActiveTab(loc)}
                          style={{ cursor: "pointer" }}
                        >
                          {selectedLocations.find(item => item.value === parseInt(loc)).label}
                        </NavLink>
                      </NavItem>
                    )
                  })}
                  {Object.keys(reports).length > 1 && (
                    <NavItem className="accordion-gradient-border">
                      <NavLink
                        className={classnames({ active: activeTab === "COMBINED" })}
                        onClick={() => setActiveTab("COMBINED")}
                        style={{ cursor: "pointer" }}
                      >
                        COMBINED
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>

                <TabContent activeTab={activeTab} className="pt-3">
                  {Object.entries(reports).map(([loc, data]) => {
                    const stats = computeReportStats([data], true)
                    return (
                      <TabPane tabId={loc} key={loc}>
                        <ReportStatsView stats={stats} />
                      </TabPane>
                    )
                  })}
                  {Object.keys(reports).length > 1 && (
                    <TabPane tabId="COMBINED">
                      <ReportStatsView stats={combinedStats} />
                    </TabPane>
                  )}
                </TabContent>
              </>
            )}
          </>
        )}
      </Container>
    </div >
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Dashboard)